/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum RealAssetType {
    VESSEL = 'vessel',
    TENDER_VESSEL = 'tender_vessel',
    ROV = 'rov',
    SUBMERSIBLE = 'submersible',
    MULTIBEAM_ECHOSOUNDER = 'multibeam_echosounder',
    SPLIT_BEAM_ECHOSOUNDER = 'split_beam_echosounder',
    SUB_BOTTOM_PROFILER = 'sub_bottom_profiler',
    ACOUSTIC_DOPPLER_CURRENT_PROFILER = 'acoustic_doppler_current_profiler',
    POSITIONING_SYSTEM = 'positioning_system',
    SOUND_SPEED_EQUIPMENT = 'sound_speed_equipment',
    CAMERA = 'camera',
}
